(function () {
    "use strict";

    var PeriodSnapshotParameterControl = Solovis.defineClass(
        "Solovis.Reports.Parameters.PeriodSnapshotParameterControl",
        Solovis.UI.BaseControl,
        function (options) {
            this.parameterList = options.parameterList;
            this.parameterSet = this.parameterList.parameterSet;            

            this.initialParameterValue = (typeof options.initialValue != "undefined") ? options.initialValue : null;
            this.currentSnapshot = this.initialParameterValue;

            var settings = options.settings ? options.settings : {};

            this._entityParam = null;
            this._periodEndDayIdParam = null;
            if (settings.dependsOn) {
                this._entityParam = settings.dependsOn.entity ? settings.dependsOn.entity : null;
                this._periodEndDayIdParam = settings.dependsOn.periodEndDayId ? settings.dependsOn.periodEndDayId : null;
            }

            if (!this._entityParam) {
                console.log("Error: PeriodSnapshotParameterControl requires settings.dependsOn.entity");
            }
            if (!this._periodEndDayIdParam) {
                console.log("Error: PeriodSnapshotParameterControl requires settings.dependsOn.periodEndDayId");
            }
        });


    var getSnapshotInfoFromSnapshotData = function (snapshotData) {
        var snapshotInfo = {
            periodSnapshotId: snapshotData.id,
            label: PeriodSnapshotParameterControl.getLabel(snapshotData),
            entityId: snapshotData.entityId,
            periodEndDayId: snapshotData.periodEndDayId
        };

        return snapshotInfo;
    };


    PeriodSnapshotParameterControl.preload = function (newValue, callback) {        
        if (newValue && newValue.periodSnapshotId) {            
            Solovis.Rpc.invoke(
                "~/Rpc/DataSource/LoadDataSet",
                { path: "/Solovis/PeriodSnapshots/PeriodSnapshotList", options: { periodSnapshotId: newValue.periodSnapshotId } },
                function (response, success) {                    
                    if (success) {                        
                        var snapshotData = response.result.dataSet.periodSnapshots[0];
                        var snapshotInfo = getSnapshotInfoFromSnapshotData(snapshotData);
                        callback(snapshotInfo, true);
                    }
                    else {
                        callback(null, false);
                    }
                });        
        }
        else {           
            callback(null, true);
        }
    };

    PeriodSnapshotParameterControl.serializeParameterValue = function (value) {
        if (value) {
            if (value.periodSnapshotId) {
                return { periodSnapshotId: value.periodSnapshotId };
            }            
        }

        return null;
    };


    PeriodSnapshotParameterControl.getLabel = function (value): string | undefined {
        return value?.label;
    };

    PeriodSnapshotParameterControl.prototype.doInit = function () {
        var self = this;

        $(this.parameterSet).bind("parameterValueChanged", function () {
            self._checkForMatchingDependencies();
        });        
    };


    PeriodSnapshotParameterControl.prototype.doRender = function () {
        var self = this;

        this.selectedSnapshotLabel = $("<span>").appendTo(this.container);
        this.selectSnapshotLink = $("<a>").text("select").appendTo(this.container);                        

        this.selectSnapshotLink.click(function () {
            self._showSnapshotSelection();
        });

        // Set initial parameter value text.
        if (this.currentSnapshot) {
            this._setCurrentSnapshotData(this.currentSnapshot);
        }
    };

    PeriodSnapshotParameterControl.prototype._setCurrentSnapshotData = function (snapshotData) {
        var label = "";

        if (snapshotData) {
            label = PeriodSnapshotParameterControl.getLabel(snapshotData) + " ";
        }

        this.selectedSnapshotLabel.text(label);
    };

    PeriodSnapshotParameterControl.prototype.setParameterValue = function (newValue) {        
        this._setCurrentSnapshotData(newValue);        
    };

    PeriodSnapshotParameterControl.prototype.getParameterValue = function () {
        if (this.state < Solovis.UI.BaseControl.ControlState.afterInit) {
            return this.initialParameterValue ? this.initialParameterValue : null;
        }
        else if (this.currentSnapshot) {
            return Solovis.deepCopy(this.currentSnapshot);
        }
        else {
            return null;
        }
    };
   

    PeriodSnapshotParameterControl.prototype.notifyParameterValueChanged = function () {
        $(this).trigger("parameterValueChanged");
    };

    PeriodSnapshotParameterControl.prototype._setSelectedPeriodSnapshot = function (snapshotInfo) {
        var different = false;

        if (this.currentSnapshot && snapshotInfo) {
            if (this.currentSnapshot.periodSnapshotId != snapshotInfo.periodSnapshotId) {
                different = true;
            }
        }
        else if (this.currentSnapshot || this.snapshotInfo) {
            different = true;
        }

        this.currentSnapshot = snapshotInfo;
        this._setCurrentSnapshotData(this.currentSnapshot);

        if (different) {
            this.notifyParameterValueChanged();
        }
    };

    PeriodSnapshotParameterControl.prototype._showSnapshotSelection = function () {
        var self = this;

        var entity = this.parameterSet.getParameterValue(this._entityParam);
        var periodEndDayId = this.parameterSet.getParameterValue(this._periodEndDayIdParam);

        if (entity && periodEndDayId) {
            Solovis.Rpc.invokeAndWait(
                "~/Rpc/DataSource/LoadDataSet",
                { path: "/Solovis/PeriodSnapshots/PeriodSnapshotList", options: { entityId: entity.entityId, periodEndDayId: periodEndDayId } },
                function (response, success) {
                    if (success) {
                        var periodSnapshots = response.result.dataSet.periodSnapshots;
                        self._showSnapshotSelectionDialog(periodSnapshots);
                    }
                });
        }
        else {
            Solovis.UI.alert("Entity and Period End Day must both be selected.", "Error");
        }
    };

    PeriodSnapshotParameterControl.prototype._showSnapshotSelectionDialog = function (periodSnapshots) {
        var self = this;

        var formDiv = $("<div>");
        var snapshotListDiv = $("<div>").appendTo(formDiv);

        var dialog = null;

        $(periodSnapshots).each(function (i, snapshot: any) {
            var snapshotDiv = $("<div>").appendTo(snapshotListDiv);
          
            var snapshotLink = $("<a>").text(PeriodSnapshotParameterControl.getLabel(snapshot)).appendTo(snapshotDiv);

            snapshotLink.click(function () {
                var snapshotInfo = getSnapshotInfoFromSnapshotData(snapshot);
                self._setSelectedPeriodSnapshot(snapshotInfo);
                dialog.close();
            });
        });

        dialog = new Solovis.UI.Dialog({
            container: formDiv,
            ownerDialog: Solovis.UI.Dialog.findContainingDialog(this.container),

            title: "Select Period Snapshot",
            width: 500,
            maxHeight: 300,
            autoOpen: true,
            center: true,
            modal: true,
            destroyOnClose: true,
            actions: ["Close"],

            buttons: [
                {
                    label: "Clear",
                    click: function () {
                        self._setSelectedPeriodSnapshot(null);
                        dialog.close();
                    }
                },

                {
                    label: "Cancel",
                    click: function () {
                        dialog.close();
                    }
                }
            ]
        });
    };


    PeriodSnapshotParameterControl.prototype._checkForMatchingDependencies = function () {
        // If the user changes the dependent entity or day, we should clear the value here.

        var entity = this.parameterSet.getParameterValue(this._entityParam);
        var periodEndDayId = this.parameterSet.getParameterValue(this._periodEndDayIdParam);

        if (this.currentSnapshot) {
            var different = false;

            if (entity) {
                if (entity.entityId != this.currentSnapshot.entityId) {
                    different = true;
                }
            }
            else {
                different = true;
            }

            if (periodEndDayId != this.currentSnapshot.periodEndDayId) {
                different = true;
            }

            if (different) {
                this.setParameterValue(null);
            }
        }
    };
})();